var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 22H16.5C18.433 22 20 20.433 20 18.5V9.82843C20 8.90017 19.6313 8.00993 18.9749 7.35355L14.6464 3.02513C13.9901 2.36875 13.0998 2 12.1716 2H7.5C5.567 2 4 3.567 4 5.5V18.5C4 20.433 5.567 22 7.5 22ZM7.5 20.5H16.5C17.6046 20.5 18.5 19.6046 18.5 18.5V10.5002H13.5C12.3954 10.5002 11.5 9.60475 11.5 8.50018V3.5H7.5C6.39543 3.5 5.5 4.39543 5.5 5.5V18.5C5.5 19.6046 6.39543 20.5 7.5 20.5ZM18.3204 9.00018C18.2222 8.78414 18.0853 8.58528 17.9142 8.41421L13.5858 4.08579C13.4148 3.91477 13.216 3.77792 13 3.67964V8.50018C13 8.77633 13.2239 9.00018 13.5 9.00018H18.3204Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3f2e7eac.svg";
export { ForwardRef as ReactComponent };